import React from "react";
import "./styles.css";

const banner = "assets/working-banner.jpeg";
const TileBanner = () => {
  return (
    <div className="banner">
      <img src={banner} />
      <div className="intro">
        <div>
          Hi there! I’m Rishabh Nigam—a polyglot software engineer and frequent
          public speaker. I build fast, reliable products across the stack and
          I’m the 🧭 webmaster of this little website. I started out obsessed
          with UI and fell in love with bringing designs to life end-to-end.
          These days I write about leadership, JavaScript/TypeScript, React, and
          React Native. Welcome!{" "}
          <a href="https://www.linkedin.com/in/rishabh-nigam-4024b7b0/">
            LinkedIn→
          </a>
        </div>
      </div>
    </div>
  );
};

export default TileBanner;
